




























module.exports = {
  "cs": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/cs.js"),
  "da": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/da.js"),
  "de": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/de.js"),
  "en": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/en.js"),
  "en_GB": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/en_GB.js"),
  "en_ZZ": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/en_ZZ.js"),
  "es": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/es.js"),
  "et": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/et.js"),
  "fi": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/fi.js"),
  "fr": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/fr.js"),
  "hu": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/hu.js"),
  "index": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/index.js"),
  "it": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/it.js"),
  "ja": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/ja.js"),
  "ko": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/ko.js"),
  "nb": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/nb.js"),
  "nl": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/nl.js"),
  "pl": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/pl.js"),
  "pt_BR": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/pt_BR.js"),
  "pt_PT": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/pt_PT.js"),
  "ru": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/ru.js"),
  "sk": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/sk.js"),
  "sv": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/sv.js"),
  "th": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/th.js"),
  "tr": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/tr.js"),
  "uk": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/uk.js"),
  "vi": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/vi.js"),
  "zh": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/zh.js"),
  "zh_TW": () => import("../../../../../../node_modules/@atlassian/jira-portfolio-plan-wizard/dist/esm/i18n/zh_TW.js")
}